<template lang="pug">
div
  el-row
    el-col(:span="24")
      app-resumo-cadastrante(:cadastrante="cadastro.cadastrante")
      app-resumo-interessado(
        :interessado="cadastro.interessado",
        :hasConjuge="false"
        :idCadastro="idCadastro"
      )
      app-resumo-imovel(v-if="cadastro" :imovel="cadastro.imovel" :idCadastro="idCadastro")
</template>
<script>
import AppResumoCadastrante from '@/components/resumo/AppResumoCadastrante'
import AppResumoInteressado from '@/components/resumo/AppResumoInteressado'
import AppResumoImovel from '@/components/resumo/AppResumoImovel'

import AppButton from '@/components/shared/AppButton'

export default {
  components: {
    AppButton,
    AppResumoCadastrante,
    AppResumoInteressado,
    AppResumoImovel
  },

  props: ['cadastro', 'idCadastro']
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/solicitarInformacao/components/Resumo.vue